import React from 'react';
import { Typography, type TypographyProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const Wordmark: React.FC<TypographyProps> = (props) => {
  const { t } = useTranslation();
  return (
    <Typography variant="h6" fontWeight={700} textAlign="center" {...props}>
      {t('appName')}
    </Typography>
  );
};
